import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const RouteTracker = () => {
  const location = useLocation();
  const first = useRef(true);

  useEffect(() => {
    // Initial page view is sent by the snippets in index.html
    if (first.current) {
      first.current = false;
      return;
    }
    const path = location.pathname + location.search;
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    if (window.fbq) window.fbq("track", "PageView");
  }, [location.pathname, location.search]);

  return null;
};
